export const mesafeliSozlesme = {
  title: 'Mesafeli Kullanıcı Sözleşmesi',
  sections: [
    {
      heading: '1. Taraflar',
      paragraphs: [
        'İşbu sözleşme, YolSepetiGO platformu ("Hizmet Sağlayıcı") ile platformu kullanan gerçek veya tüzel kişi ("Kullanıcı") arasında akdedilmiştir.',
      ],
    },
    {
      heading: '2. Hizmetin Kapsamı',
      paragraphs: [
        'YolSepetiGO, çekici, vinç, nakliye ve yol yardım hizmetlerinin talep edilmesi ve sürücülerle eşleştirilmesi için aracı platform hizmeti sunmaktadır.',
      ],
    },
    {
      heading: '3. Kullanıcının Yükümlülükleri',
      list: [
        'Doğru ve güncel bilgi sağlamak',
        'Platformu yasalara uygun şekilde kullanmak',
        'Hizmet bedelini zamanında ödemek',
        'Araç ve kişisel güvenlik önlemlerini almak',
      ],
    },
    {
      heading: '4. Cayma Hakkı',
      paragraphs: [
        'Kullanıcı, hizmet talebi onaylanmadan önce siparişini iptal edebilir. Hizmet başladıktan sonra cayma hakkı, ilgili mevzuat hükümleri çerçevesinde değerlendirilir.',
      ],
    },
    {
      heading: '5. Uyuşmazlık Çözümü',
      paragraphs: [
        'İşbu sözleşmeden kaynaklanan uyuşmazlıklarda İstanbul Mahkemeleri ve İcra Daireleri yetkilidir.',
      ],
    },
  ],
};
